import { Address as AddressType, Country } from '@shared/types'
import { AddressFields } from '@ui-common/components/AddressFields'
import { COUNTRY_CODE_FINLAND, getCountryName } from '@ui-common/utils'
import { COMMON_PLACEHOLDER } from '@ui-components/global/constants'

const resolveCountryName = (countryName?: string, countryCode?: string, countries?: Country[]): string =>
  countryName || (countries && countryCode && getCountryName(countries, countryCode)) || COMMON_PLACEHOLDER

const getAddress = (address: AddressType, countries?: Country[]): AddressType => {
  const result: AddressType = {}
  if (address.domesticAddress) {
    result.domesticAddress = {
      street: address.domesticAddress.street ?? COMMON_PLACEHOLDER,
      postalCode: address.domesticAddress.postalCode ?? COMMON_PLACEHOLDER,
      postOffice: address.domesticAddress.postOffice ?? COMMON_PLACEHOLDER,
      countryName: resolveCountryName(
        address.domesticAddress.countryName,
        address.domesticAddress.countryCode || COUNTRY_CODE_FINLAND,
        countries,
      ),
    }
  }
  if (address.foreignAddress) {
    result.foreignAddress = {
      street: address.foreignAddress.street ?? COMMON_PLACEHOLDER,
      foreignAddressLine1: address.foreignAddress.foreignAddressLine1,
      foreignAddressLine2: address.foreignAddress.foreignAddressLine2,
      countryName: resolveCountryName(
        address.foreignAddress.countryName,
        address.foreignAddress.countryCode,
        countries,
      ),
    }
  }
  if (!address.domesticAddress && !address.foreignAddress) {
    result.domesticAddress = {
      street: COMMON_PLACEHOLDER,
      postalCode: COMMON_PLACEHOLDER,
      postOffice: COMMON_PLACEHOLDER,
      countryName: COMMON_PLACEHOLDER,
    }
  }
  return result
}

interface AddressProps {
  address: AddressType
  /** Optional param used for country name resolving */
  countries?: Country[]
}

export const Address = ({ address, countries }: AddressProps) => (
  <AddressFields address={getAddress(address, countries)} />
)
